import React from 'react';
import { Field, RadioGroup, NumericInput, TextOutput } from '../../../../Core';
import { ListFieldSection, SectionGroup } from '../../../../Layout';
import { withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { useSelector } from 'react-redux';
import { WorksheetAssociatedTestSection, IWithWorksheetInjectedProps } from '../../../Core';
import { pipe } from 'Lib/Hooks/Selectors';
import { valueOrDefault } from 'Lib/Any';
import externalTestMethods from '../../../ExternalTestMethods';

let PreparationAsReceivedWaterContentSection: React.FC<IWithWorksheetInjectedProps> = ({ createWorksheetSelector }) => {
  const asReceivedWaterContentDetermined = useSelector(
    pipe(createWorksheetSelector!('Preparation.AsReceivedWaterContentDetermined'), valueOrDefault(false))
  );
  const importedAsReceivedWaterContentTestId = useSelector(
    createWorksheetSelector!('Preparation.AssociatedAsReceivedWaterContent.ImportedTest.Id')
  );
  return (
    <SectionGroup heading="As-Received Moisture Content">
      <ListFieldSection>
        <Field
          input={<RadioGroup />}
          label="As-Received Moisture Content Determined"
          name="Preparation.AsReceivedWaterContentDetermined"
          options={[
            { label: 'Yes', value: true },
            { label: 'No', value: false },
          ]}
          confirm={asReceivedWaterContentDetermined}
          confirmTitle="As-Received Moisture Content Deletion"
          confirmText="Any existing data for the as-received moisture content will be removed."
          confirmButtonText="Delete"
        />
      </ListFieldSection>
      {asReceivedWaterContentDetermined && (
        <WorksheetAssociatedTestSection
          label="As-Received Moisture Content Determined By:"
          name="Preparation.AssociatedAsReceivedWaterContent"
          testType="Moisture Content"
          associatedTestModel={{
            measured: true,
            imported: {
              importedTestResults: (
                <ListFieldSection>
                  <Field
                    input={<TextOutput />}
                    label="As-Received Moisture Content (%)"
                    name="Preparation.AsReceivedWaterContent"
                    emph
                  />
                </ListFieldSection>
              ),
              importModel: {
                Id: importedAsReceivedWaterContentTestId,
              },
            },
            external: {
              testMethods: [externalTestMethods.moistureContent.AASHTO_T_265],
              permitOtherTestMethods: true,
              externalTestResults: (
                <ListFieldSection>
                  <Field
                    input={<NumericInput />}
                    label="As-Received Moisture Content (%)"
                    name="Preparation.AssociatedAsReceivedWaterContent.ExternalTest.Results.MoistureContentPercent"
                  />
                </ListFieldSection>
              ),
            },
          }}
        />
      )}
    </SectionGroup>
  );
};

PreparationAsReceivedWaterContentSection = withInjectedProps(PreparationAsReceivedWaterContentSection);

export { PreparationAsReceivedWaterContentSection };
export default PreparationAsReceivedWaterContentSection;
